import moment from 'moment-timezone'

export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss' // Example: 2024-07-11 14:30:00
export const DEFAULT_DATE_VALUE_FORMAT = 'YYYY-MM-DDT00:00:00.000' // Example: 2024-07-11T14:30:00
export const DEFAULT_DATE_VALUE_FORMAT_WITH_TZ = 'YYYY-MM-DDT00:00:00.000Z' // Example: 2024-08-23T00:00:00.000Z
export const DEFAULT_DATE_FORMAT_WITHOUT_TIME = 'YYYY-MM-DD' // Example: 2024-07-11
export const DATE_TIME_WITH_DAY_FORMAT = 'MM/DD/YYYY [at] h:mm A' // Example: 07/11/2024 at 2:30 PM
export const DATE_DAY_AND_TIME_WITH_DAY_FORMAT_EXTENDED = 'dddd MMM DD YYYY, hh:mma' // Example: Friday Aug 23 2024, 03:45pm
export const DATE_ONLY_FORMAT = 'MMM DD YYYY' // Example: Jul 11 2024
export const DATE_TIME_FORMAT = 'MMM DD YYYY, h:mma' // Example: Jul 11 2024, 2:30pm
export const DATE_TIME_FORMAT_EXTEND = 'MM/DD/YYYY hh:mma' // Example: 07/11/2024 02:30pm
export const DATE_FORMAT_SLASH = 'MM/DD/YYYY' // Example: 07/11/2024
export const DATE_FORMAT_DASH = 'MM-DD-YYYY' // Example: 07-11-2024
export const TIME_FORMAT = 'h:mm A' // Example: 2:30 PM
export const EXTEND_TIME_FORMAT = 'hh:mm A' // Example: 02:30 PM"
export const EXTEND_TIME_FORMAT_SMALL = 'hh:mm a' // Example: 02:30 pm"
export const MONTH_FORMAT = 'MM'
export const DAY_FORMAT = 'DD'
export const YEAR_FORMAT_FULL = 'YYYY'
export const YEAR_FORMAT_SHORT = 'YY'
export const DATE_FORMAT_MM_YY = 'MM/YY' // Example: 07/24
export const DATE_TIME_UTC_FORMAT = 'M/D/YYYY, h:mm:ss.SS A' // Example: 7/11/2024, 2:30:00.00 PM
export const DATE_TIME_ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ' // Example: 2024-07-11T14:30:00.000Z

export const TIME_FOR_DATE_RANGE_REQUEST_FROM = 'YYYY-MM-DDT00:00:00.000Z' // Example: 2024-07-11T14:30:00.000Z
export const TIME_FOR_DATE_RANGE_REQUEST_TO = 'YYYY-MM-DDT23:59:59.000Z' // Example: 2024-07-11T14:30:00.000Z
export const MONTH_DAY_DATE_FORMAT = 'dddd MMM D YYYY' // Example: Friday Aug 23 2024

export const UNITS = {
  MINUTE: 'minute',
  MINUTES: 'minutes',
  DAY: 'day',
  DAYS: 'days',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
}
export const dateHelper = {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  formatDate: (date, format = DEFAULT_DATE_FORMAT) => moment(date).format(format),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  formatDateTimeToISO: (date, time) => moment(`${date} ${time}`).format(DATE_TIME_ISO_FORMAT),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  formatTimeWithDate: (date, time, format = TIME_FORMAT) => moment(`${date} ${time}`).format(format),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  formatDateUTC: (date, format = DEFAULT_DATE_FORMAT) => moment(date).utc().format(format),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  parseDate: (dateString, format = DEFAULT_DATE_FORMAT) => moment(dateString, format).toDate(),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  dateDifference: (date1, date2, unit = UNITS.DAYS) => moment(date1).diff(moment(date2), unit),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  addTime: (date, amount, unit = UNITS.DAYS) => moment(date).add(amount, unit).toDate(),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  subtractTime: (date, amount, unit = UNITS.DAYS) => moment(date).subtract(amount, unit).toDate(),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  isValidDate: (dateString, format = DEFAULT_DATE_FORMAT) => moment(dateString, format, true).isValid(),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  startOf: (date, unit = UNITS.DAY) => moment(date).startOf(unit).toDate(),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  endOf: (date, unit = UNITS.DAY) => moment(date).endOf(unit).toDate(),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  isAfter: (date, comparisonDate) => moment(date).isAfter(moment(comparisonDate)),
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  isBefore: (date, comparisonDate) => moment(date).isBefore(moment(comparisonDate)),
  getTimeInMilliseconds: () => moment().valueOf(),
}
